export default __webpack_public_path__ + "static/media/golden_hours_maxime.4b130342.jpg";